/* MDA — fiche produit (template product.mda). Amelioration progressive : sans ce fichier, la page reste
   complete (galerie defilable, ajout au panier natif, FAQ lisible, avis complets, texte integral). Ajout panier AJAX : mda-core.js. */
(function () {
  'use strict';
  if (window.__mdaPdp) return; window.__mdaPdp = 1;
  var d = document, w = window;
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); };
  var hasIO = 'IntersectionObserver' in w;
  var root = d.querySelector('[data-mda-pdp]');

  /* 0. Mesure CRO : evenements pdp_* (dataLayer + Shopify customer events). Aucune donnee personnelle. */
  function device() { var x = w.innerWidth || 0; return x < 750 ? 'mobile' : (x < 990 ? 'tablet' : 'desktop'); }
  function track(name, pos, extra) {
    if (!root) return;
    var data = {
      product_handle: root.getAttribute('data-product-handle') || '',
      product_id: +root.getAttribute('data-product-id') || 0,
      price: (+root.getAttribute('data-price') || 0) / 100,
      device_type: device(),
      device: device(),
      source_product: +root.getAttribute('data-product-id') || 0,
      source_position: pos || '',
      payment_order: d.documentElement.getAttribute('data-mda-pay') || root.getAttribute('data-pay-order') || ''
    };
    if (extra) for (var k in extra) data[k] = extra[k];
    try { (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* Payload recommandation : produit recommande, type de relation, position, coffret (aucune donnee personnelle) */
  function recData(el, fallbackRel) {
    if (!el) return {};
    var pid = +(el.getAttribute('data-mda-rec') || el.getAttribute('data-mda-reco-pid') || el.getAttribute('data-mda-shown-pid') || 0);
    var rel = el.getAttribute('data-mda-rel') || fallbackRel || '';
    return { recommended_product: pid, target_product_id: pid, relation_type: rel, position: +(el.getAttribute('data-mda-rpos') || 0), bundle: /bundle/.test(rel) };
  }

  /* 1. Galerie : compteur + vignettes (IntersectionObserver sur le rail natif) */
  function initGallery(g) {
    var track_ = g.querySelector('[data-mda-gtrack]'); if (!track_) return;
    var slides = $$('.mda-pdpg__slide', track_), thumbs = $$('[data-mda-gthumb]', g), idx = g.querySelector('[data-mda-gidx]');
    var cur = 0, seen = {};
    function setActive(i) {
      if (i !== cur && !seen[i]) { seen[i] = 1; track('pdp_gallery_interaction', 'gallery', { media_index: i }); }
      cur = i;
      if (idx) idx.textContent = i + 1;
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    if (hasIO && slides.length > 1) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(+e.target.getAttribute('data-index')); });
      }, { root: track_, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(g, +t.getAttribute('data-mda-gthumb')); });
    });
  }
  function goTo(g, i) {
    var t = g.querySelector('[data-mda-gtrack]'); if (!t) return;
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollTo({ left: i * t.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* 2. Videos (galerie + UGC) : rien n'est charge avant le clic ; une seule lecture a la fois */
  function pauseOthers(except) { $$('video').forEach(function (v) { if (v !== except && !v.paused) { try { v.pause(); } catch (e) {} } }); }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mda-video],[data-mda-embed]'); if (!b) return;
    e.preventDefault();
    var box = b.parentNode, poster = b.querySelector('img'), el;
    var ugc = b.closest('.mda-pdpx__item');
    if (b.hasAttribute('data-mda-embed')) {
      el = d.createElement('iframe');
      el.src = b.getAttribute('data-mda-embed');
      el.allow = 'autoplay; encrypted-media; picture-in-picture'; el.allowFullscreen = true; el.title = 'Vidéo';
    } else {
      var list = []; try { list = JSON.parse(b.getAttribute('data-mda-video') || '[]'); } catch (err) {}
      if (!list.length) return;
      var target = (w.innerWidth || 0) < 750 ? 720 : 1080;
      list.sort(function (x, y) { return Math.abs(x.h - target) - Math.abs(y.h - target); });
      el = d.createElement('video');
      el.controls = true; el.playsInline = true; el.setAttribute('playsinline', ''); el.preload = 'auto';
      if (poster) el.poster = poster.currentSrc || poster.src;
      var src = d.createElement('source'); src.src = list[0].url; src.type = list[0].type || 'video/mp4'; el.appendChild(src);
      el.addEventListener('play', function () { pauseOthers(el); });
    }
    box.replaceChild(el, b);
    if (ugc) {
      ugc.classList.add('is-playing');
      track('pdp_ugc_play', 'ugc', { video_index: $$('.mda-pdpx__item').indexOf(ugc) });
    } else {
      track('pdp_gallery_interaction', 'gallery_video');
    }
    if (el.tagName === 'VIDEO') { var p = el.play(); if (p && p.catch) p.catch(function () {}); el.focus && el.focus(); }
  });

  /* 3. Variantes (seulement si le produit en a plusieurs) */
  function initVariants(r) {
    var data = r.querySelector('[data-mda-pdp-variants]'); if (!data) return;
    var variants = []; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var form = r.querySelector('form[data-mda-add]'); if (!form) return;
    var idInput = form.querySelector('[data-mda-variant-id]');
    var sets = $$('[data-mda-option]', form);
    form.addEventListener('change', function (e) {
      if (!e.target.closest('[data-mda-option]')) return;
      var sel = sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      update(r, v, idInput);
    });
  }
  function update(r, v, idInput) {
    var atc = r.querySelector('[data-main-atc]'), label = r.querySelector('[data-mda-atc-label]'), sBtn = r.querySelector('[data-sticky-btn]'), sLab = r.querySelector('[data-mda-sticky-label]');
    var ok = !!(v && v.available);
    if (v) { idInput.value = v.id; if (v.cents) r.setAttribute('data-price', v.cents); }
    [atc, sBtn].forEach(function (b) { if (b) b.disabled = !ok; });
    var txt = !v ? 'Indisponible' : (ok ? 'Ajouter au panier' : 'Épuisé');
    if (label) label.textContent = txt; if (sLab) sLab.textContent = txt;
    if (!v) return;
    var now = r.querySelector('[data-mda-price-now]'), was = r.querySelector('[data-mda-price-was]'), unit = r.querySelector('[data-mda-price-unit]'), st = r.querySelector('[data-mda-price-sticky]'), save = r.querySelector('[data-mda-price-save]');
    if (now) now.textContent = v.price; if (st) st.textContent = v.price;
    if (was) { was.hidden = !v.compare; if (v.compare) was.lastChild.textContent = v.compare; }
    if (save) save.hidden = !v.compare;
    if (unit) { unit.hidden = !v.unit; unit.textContent = v.unit || ''; }
    try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u.toString()); } catch (e) {}
    if (v.media) {
      var g = r.querySelector('[data-mda-gallery]'), slide = g && g.querySelector('[data-media-id="' + v.media + '"]');
      if (slide) goTo(g, +slide.getAttribute('data-index'));
    }
  }

  /* 4. Barre panier collante (mobile) : cachee au chargement. Visible seulement si
        (a) le visiteur a commence a descendre (repere [data-mda-sticky-arm] sorti par le haut, ~160 px)
        ET (b) le bouton principal est hors ecran. Deux IntersectionObserver, aucune ecoute scroll.
        Etats recopies du bouton principal : chargement, ajoute, erreur, epuise. Cachee clavier ouvert / tiroir ouvert (CSS). */
  function initSticky(r) {
    var main = r.querySelector('[data-main-atc]'), sticky = r.querySelector('[data-sticky-atc]'), arm = r.querySelector('[data-mda-sticky-arm]');
    if (!main || !sticky || !hasIO) return;
    var btn = sticky.querySelector('[data-sticky-btn]'), lab = sticky.querySelector('[data-mda-sticky-label]');
    var armed = false, mainVisible = true;
    function apply() {
      var show = armed && !mainVisible;
      sticky.toggleAttribute('data-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      d.documentElement.classList.toggle('mda-pdps-on', show);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (es) { mainVisible = es[0].isIntersecting; apply(); }, { threshold: 0.15 }).observe(main);
    if (arm) {
      new IntersectionObserver(function (es) { var e = es[0]; armed = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }).observe(arm);
    } else { armed = true; }
    /* etats du bouton principal -> barre */
    var base = lab ? lab.textContent : '';
    function mirror() {
      if (!btn || !lab) return;
      var busy = main.getAttribute('aria-busy') === 'true', done = main.hasAttribute('data-done'), err = main.hasAttribute('data-error');
      btn.toggleAttribute('aria-busy', busy); btn.toggleAttribute('data-done', done); btn.toggleAttribute('data-error', err);
      btn.disabled = main.disabled;
      lab.textContent = main.disabled ? (r.querySelector('[data-mda-atc-label]') || {}).textContent || base : busy ? 'Ajout…' : done ? 'Ajouté ✓' : err ? 'Réessayer' : ((r.querySelector('[data-mda-atc-label]') || {}).textContent || base);
    }
    if ('MutationObserver' in w) new MutationObserver(mirror).observe(main, { attributes: true, attributeFilter: ['aria-busy', 'data-done', 'data-error', 'disabled'] });
    /* clavier virtuel : champ de saisie actif -> barre masquee */
    d.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea,select')) sticky.setAttribute('data-kb', ''); });
    d.addEventListener('focusout', function () { sticky.removeAttribute('data-kb'); });
    /* retour arriere (cache de page) : aucun bouton fige */
    w.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      ['aria-busy', 'aria-disabled', 'data-done', 'data-error'].forEach(function (a) { main.removeAttribute(a); });
      mirror();
    });
  }

  /* 5. Livraison offerte : avant ajout, le message compte CE soin ; apres ajout, le panier reel */
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }
  function initShipping(r) {
    var box = r.querySelector('[data-mda-ship]'); if (!box) return;
    var min = +box.getAttribute('data-min') || 0, txt = box.querySelector('[data-mda-ship-text]'), bar = box.querySelector('[data-mda-ship-bar]');
    var after = box.getAttribute('data-after') || '', afterOk = box.getAttribute('data-after-ok') || '';
    function esc(s) { var x = d.createElement('span'); x.textContent = s; return x.innerHTML; }
    d.addEventListener('cart:item-added', function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (c) {
        var left = min - c.total_price;
        if (txt) txt.innerHTML = left > 0 ? esc(after).replace('[montant]', '<strong>' + money(left) + '</strong>') : esc(afterOk);
        if (bar) bar.style.width = Math.min(100, Math.round(c.total_price * 100 / min)) + '%';
      }).catch(function () {});
    });
  }

  /* 6. Recommandations : chargees quand la section approche de l'ecran ; une seule place par produit */
  function initReco() {
    $$('[data-mda-reco]').forEach(function (sec) {
      var load = function () {
        fetch(sec.getAttribute('data-mda-reco')).then(function (res) { return res.ok ? res.text() : ''; }).then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html'), next = doc.querySelector('[data-mda-reco]');
          if (!next) return;
          var seen = {}; seen[sec.getAttribute('data-mda-pid')] = 1;
          $$('[data-mda-shown-pid]').forEach(function (el) { seen[el.getAttribute('data-mda-shown-pid')] = 1; });
          var max = +sec.getAttribute('data-mda-reco-limit') || 4, kept = 0;
          $$('[data-mda-reco-pid]', next).forEach(function (li) {
            if (seen[li.getAttribute('data-mda-reco-pid')] || kept >= max) li.parentNode.removeChild(li); else kept++;
          });
          if (!kept) return;
          sec.innerHTML = next.innerHTML; sec.classList.add('is-loaded');
          if (hasIO) { var vio = new IntersectionObserver(function (es) { if (es[0].isIntersecting && es[0].intersectionRatio >= 0.25) { vio.disconnect(); track('pdp_related_view', 'related', { count: kept, relation_type: 'related_api' }); } }, { threshold: [0.25] }); vio.observe(sec); }
        }).catch(function () {});
      };
      if (!hasIO) { load(); return; }
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
    });
  }

  /* 7. Texte long : replie avec « Lire la suite » (le texte complet reste dans le HTML) */
  function initLongform() {
    $$('[data-mda-longform]').forEach(function (body) {
      if (body.scrollHeight < 760) return;
      body.classList.add('is-clamped');
      var btn = d.createElement('button');
      btn.type = 'button'; btn.className = 'mda-link mda-pdpl__more'; btn.textContent = 'Lire la suite';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Réduire' : 'Lire la suite';
      });
      body.parentNode.appendChild(btn);
    });
  }

  /* 8. Avis Klaviyo : habillage seulement. Les N premiers avis visibles, le reste (et « Afficher plus » de Klaviyo)
        masque jusqu'au clic sur « Voir les X avis ». Aucun avis duplique, widget et pagination Klaviyo intacts. */
  function initReviews() {
    var app = d.querySelector('[data-mda-reviews]'); if (!app) return;
    var wrap = d.querySelector('[data-mda-reviews-more-wrap]'), btn = d.querySelector('[data-mda-reviews-more]');
    var n = +app.getAttribute('data-visible-count') || 3, open = false, mo;
    function applyHide() {
      if (open) return;
      var items = $$('.kl_reviews__review_item', app);
      if (items.length <= n) return;
      items.forEach(function (it, i) { if (i >= n) it.setAttribute('data-mda-hide', ''); });
      $$('button', app).forEach(function (b) { if (/afficher plus|show more|voir plus/i.test(b.textContent || '')) b.setAttribute('data-mda-hide', ''); });
      app.classList.add('is-collapsed');
      if (wrap) wrap.hidden = false;
    }
    if ('MutationObserver' in w) { mo = new MutationObserver(applyHide); mo.observe(app, { childList: true, subtree: true }); }
    applyHide();
    if (btn) btn.addEventListener('click', function () {
      open = true; if (mo) mo.disconnect();
      $$('[data-mda-hide]', app).forEach(function (el) { el.removeAttribute('data-mda-hide'); });
      app.classList.remove('is-collapsed');
      if (wrap) wrap.hidden = true;
      track('pdp_reviews_expand', 'reviews_more');
    });
  }

  /* 9. Comparatif (mobile) : les N premieres differences d'emblee, le detail au clic. Sans JS : tout visible. */
  function initComparatif() {
    var box = d.querySelector('[data-mda-cmp]'); if (!box || (w.innerWidth || 0) >= 750) return;
    var n = +box.getAttribute('data-visible-rows') || 3, wrap = d.querySelector('[data-mda-cmp-more-wrap]'), btn = d.querySelector('[data-mda-cmp-more]');
    var hidden = [];
    $$('.mda-comparison-clean__list', box).forEach(function (list) {
      $$('.mda-comparison-clean__item', list).forEach(function (it, i) { if (i >= n) hidden.push(it); });
    });
    var rows = $$('.comparison-row', box).filter(function (row) { return !row.classList.contains('comparison-title'); });
    rows.forEach(function (row, i) { if (i >= n) hidden.push(row); });
    if (!hidden.length) return;
    hidden.forEach(function (el) { el.setAttribute('data-mda-hide', ''); });
    if (wrap) wrap.hidden = false;
    if (btn) btn.addEventListener('click', function () {
      hidden.forEach(function (el) { el.removeAttribute('data-mda-hide'); });
      if (wrap) wrap.hidden = true;
    });
  }

  /* 10. Evenements CRO */
  function initEvents(r) {
    track('pdp_view', 'page');
    /* Ordre de paiement affiché (A/B) : toujours ; exposition au test seulement si le test est actif */
    var xp = w.__mdaPayXp;
    track('pdp_payment_order_variant', 'buybox', { variant: xp ? xp.variant : (r.getAttribute('data-pay-order') || ''), variant_source: xp ? xp.source : 'setting' });
    if (xp) track('experiment_payment_order', 'buybox', { experiment_id: xp.id, variant: xp.variant, variant_source: xp.source });
    /* Entonnoir : blocs vus (une fois chacun) — [data-mda-seen="nom_evenement"] */
    if (hasIO) {
      var seenIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var need = Math.min(160, e.boundingClientRect.height * 0.5);
          if (e.intersectionRect.height < need) return;
          seenIO.unobserve(e.target);
          track(e.target.getAttribute('data-mda-seen'), e.target.getAttribute('data-mda-seen-pos') || e.target.getAttribute('data-mda-section') || 'page', e.target.hasAttribute('data-mda-rel') ? recData(e.target) : (e.target.hasAttribute('data-count') ? { count: +e.target.getAttribute('data-count') } : null));
        });
      }, { threshold: [0, 0.1, 0.25, 0.5, 1] });
      $$('[data-mda-seen]').forEach(function (el) { seenIO.observe(el); });
    }
    var lastBnpl = 0;
    d.addEventListener('click', function (e) {
      var t = e.target;
      /* Widgets tiers : on n'ecoute que le clic qui remonte jusqu'a NOTRE conteneur (aucun acces a l'interieur du widget). */
      if (t.closest && t.closest('[data-mda-bnpl]')) {
        var now = Date.now(); if (now - lastBnpl > 2000) { lastBnpl = now; track('pdp_scalapay_interaction', 'buybox'); }
        return;
      }
      if (t.closest && t.closest('.mda-pdpb__express')) {
        var more = t.closest('.shopify-payment-button__more-options');
        track('pdp_shop_pay_click', more ? 'buybox_more_options' : 'buybox');
        return;
      }
      var ben = t.closest && t.closest('[data-mda-benefit]');
      if (ben) { track('pdp_benefit_interaction', 'benefits', { benefit_index: +ben.getAttribute('data-mda-benefit') || 0 }); return; }
      if (t.closest && t.closest('[data-mda-section="pdp-reviews"]') && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || (t.closest('[class*="media"],[class*="image"],[class*="photo"]')))) track('pdp_review_media_click', 'reviews');
      if (t.closest && t.closest('[data-mda-section="pdp-proof"]') && t.closest('button,a,video')) track('pdp_social_media_click', 'social_proof');
      var a = t.closest && t.closest('a,button'); if (!a) return;
      if (a.matches('.mda-pdpb__rating')) track('pdp_review_anchor_click', 'buybox_rating');
      else if (a.hasAttribute('data-mda-bundle-link')) track('pdp_bundle_click', 'buybox_bundle', recData(a, 'primary_bundle'));
      else if (a.hasAttribute('data-sticky-btn')) track('pdp_sticky_add_to_cart', 'sticky');
      else if (a.tagName === 'A' && a.closest('[data-mda-section="pdp-routine"]')) {
        var st = a.closest('[data-mda-shown-pid]'), pid = st ? +st.getAttribute('data-mda-shown-pid') : 0;
        if (st && st.classList.contains('mda-pdpro__box')) track('pdp_bundle_click', 'routine_box', recData(st, 'routine_bundle'));
        else track('pdp_routine_product_click', 'routine', Object.assign(recData(st, 'routine_step'), { step: st ? $$('.mda-pdpro__step').indexOf(st) + 1 : 0 }));
      }
      else if (a.tagName === 'A' && a.closest('[data-mda-reco]')) {
        var li = a.closest('[data-mda-reco-pid]');
        track('pdp_related_click', 'related', Object.assign(recData(li, 'related'), { rank: li ? $$('[data-mda-reco-pid]').indexOf(li) + 1 : 0 }));
      }
    }, true);
    d.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.hasAttribute || !f.hasAttribute('data-mda-add')) return;
      var sec = f.closest('[data-mda-section]'), where = sec ? sec.getAttribute('data-mda-section') : '';
      if (where === 'pdp-main') track('pdp_add_to_cart', e.submitter && e.submitter.hasAttribute('data-sticky-btn') ? 'sticky' : 'buybox');
      else if (where === 'pdp-routine') {
        var rs = f.closest('[data-mda-shown-pid]');
        if (rs && rs.classList.contains('mda-pdpro__box')) track('pdp_bundle_add', 'routine_box', recData(rs, 'routine_bundle'));
        else track('pdp_routine_add', 'routine', recData(rs, 'routine_step'));
      }
      else if (where === 'pdp-proof') track('pdp_add_to_cart', 'ugc_chip');
      else if (where === 'pdp-related') track('pdp_related_add', 'related', recData(f.closest('[data-mda-reco-pid]'), 'related'));
    }, true);
  }

  /* 11. Scalapay : le widget officiel est injecte par l'app ; si rien n'est rendu (pays non eligible, montant hors seuils), on libere la place reservee. */
  function initBnpl() {
    var boxes = $$('[data-mda-bnpl]'); if (!boxes.length) return;
    var check = function () { boxes.forEach(function (b) { var wd = b.querySelector('scalapay-widget'); if (!wd || !wd.shadowRoot || !wd.getBoundingClientRect().height) b.classList.add('is-empty'); else b.classList.remove('is-empty'); }); };
    var run = function () {
      setTimeout(function () {
        check();
        /* le widget se masque seul hors seuils (montant min/max) : on suit sa hauteur pour ne pas laisser de vide */
        if ('ResizeObserver' in w) boxes.forEach(function (b) { var wd = b.querySelector('scalapay-widget'); if (wd) new ResizeObserver(check).observe(wd); });
      }, 2500);
    };
    if (d.readyState === 'complete') run(); else w.addEventListener('load', run);
  }

  /* 12. Prototype routine : « ajouter les soins de la routine » (bouton secondaire, désactivé par défaut dans le thème) */
  function initAddAll() {
    $$('[data-mda-add-all]').forEach(function (b) {
      var st = b.parentNode.querySelector('[data-mda-add-all-status]');
      b.addEventListener('click', function () {
        var items = b.getAttribute('data-mda-add-all').split(',').map(function (x) { var p = x.split(':'); return { id: +p[0], quantity: +p[1] || 1 }; }).filter(function (x) { return x.id; });
        if (!items.length) return;
        b.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (res) { if (!res.ok) throw 0; return res.json(); })
          .then(function () {
            track('pdp_routine_add_all', 'routine', { relation_type: b.getAttribute('data-mda-add-all-kind') === 'bundle' ? 'routine_bundle' : 'routine_all', recommended_product: +(b.getAttribute('data-mda-rec') || 0), items_count: items.length, bundle: b.getAttribute('data-mda-add-all-kind') === 'bundle' });
            if (st) st.textContent = 'Ajouté au panier.';
            try { d.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
          })
          .catch(function () { if (st) st.textContent = 'Ajout impossible pour le moment.'; })
          .then(function () { b.removeAttribute('aria-busy'); });
      });
    });
  }

  function init() {
    $$('[data-mda-gallery]').forEach(initGallery);
    $$('[data-mda-pdp]').forEach(function (r) { initVariants(r); initSticky(r); initShipping(r); });
    initReco(); initLongform(); initReviews(); initComparatif(); initBnpl(); initAddAll();
    if (root) initEvents(root);
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
